import { TableDefinition } from "features/shared/types/table";
import { Article } from "../types/article";

const ARTICLE_TABLE: TableDefinition<Article> = {
    rowTemplate: [
        {
            header: "Created On",
            accessor: "properties:creationTimestamp",
            flex: 1,
            rowAccessor: (row) =>
                row.properties?.creationTimestamp
                    ? new Date(row.properties.creationTimestamp).toLocaleString(
                          "th-TH"
                      )
                    : "-",
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Last Updated",
            accessor: "properties:updateTimestamp",
            flex: 1,
            rowAccessor: (row) =>
                row.properties?.updateTimestamp
                    ? new Date(row.properties.updateTimestamp).toLocaleString(
                          "th-TH"
                      )
                    : "-",
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Name (EN)",
            accessor: "properties:name:en",
            flex: 2,
            isShown: true,
            minCellWidth: 300,
        },
        {
            header: "Name (TH)",
            accessor: "properties:name:th",
            flex: 2,
            isShown: true,
            minCellWidth: 300,
        },
        {
            header: "View Count",
            accessor: "properties:viewCount",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Rank",
            accessor: "properties:rank",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Description (EN)",
            accessor: "properties:description:en",
            flex: 3,
            isShown: true,
            minCellWidth: 400,
        },
        {
            header: "Description (TH)",
            accessor: "properties:description:th",
            flex: 3,
            isShown: true,
            minCellWidth: 400,
        },
        {
            header: "Image",
            accessor: "properties:image",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Article ID",
            accessor: "id",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
    ],
    defaultSortKey: "properties:creationTimestamp",
};

export default ARTICLE_TABLE;
